import React from "react";
import * as R from "ramda";

import Map from "components/guides/ZoningDetails/Map";
import { useAnswerContext } from "contexts/answerContext";

const ZoningMap = () => {
  const { record } = useAnswerContext();
  const address = R.path(["answers", "address"], record);

  if (!address) return null;

  return <Map width={800} height={250} zoom={16} address={address} />;
};

export default ZoningMap;
